export const NAVIGATION = {
  MESSAGES: 'messages',
  NOTIFICATIONS: 'notifications',
  ACCOUNT: 'account'
}
